import MonitorReducerEnhancer from "../reducers/MonitorReducer";
import { applyMiddleware, compose, createStore, StoreEnhancer } from "redux";
import loggerMiddleware from '../middleware/Logger';
import thunkMiddleware from 'redux-thunk'
import { rootReducer } from "../reducers/RootReducer";

export default function ConfigureStore(preloadedState?: any) {
    const middleWares = [loggerMiddleware, thunkMiddleware]
    const middlewareEnhancer = applyMiddleware(...middleWares)
    const enhancers = [middlewareEnhancer, MonitorReducerEnhancer]
    const composedEnhancers: StoreEnhancer = compose(...enhancers)
    return createStore(rootReducer, preloadedState, composedEnhancers)
}